"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _CircleModule = _interopRequireDefault(require("../../styles/components/Circles/Circle.module.css"));
var _constants = require("../../utils/constants");
var _useGetCircle = require("../../hooks/useGetCircle");
var _Circle = require("./Circle");
var _FlowCircle = require("./FlowCircle");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Circles = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    thingPDIDDevice,
    isCorrectValue = false,
    displayNameId,
    type = _constants.circleType.temperature
  } = _ref;
  const {
    firstCircle,
    secondCircle,
    transition,
    showDefault
  } = (0, _useGetCircle.useGetCircle)({
    type,
    displayNameId,
    thingPDIDDevice
  });
  const typeFlow = type === _constants.circleType.flow;
  const typePower = type === _constants.circleType.power;
  return (0, _paulCorePackage.useDeepMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-center ".concat(_CircleModule.default.circle_wrap, " ").concat(typeFlow ? _CircleModule.default.flow : '', " ").concat(typePower ? _CircleModule.default.power : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _CircleModule.default.circle_animation
  }, showDefault ? null : isCorrectValue && (firstCircle || secondCircle) ?
  /*#__PURE__*/
  // ? animateCircleGrey :
  _react.default.createElement(_react.default.Fragment, null, firstCircle ? typeFlow ? /*#__PURE__*/_react.default.createElement(_FlowCircle.FlowCircle, {
    isTransition: transition === _constants.circles.first,
    animationData: firstCircle,
    thingPDIDDevice: thingPDIDDevice
  }) : /*#__PURE__*/_react.default.createElement(_Circle.Circle, {
    isTransition: transition === _constants.circles.first,
    animationData: firstCircle
  }) : null, secondCircle ? typeFlow ? /*#__PURE__*/_react.default.createElement(_FlowCircle.FlowCircle, {
    isTransition: transition === _constants.circles.second,
    animationData: secondCircle,
    thingPDIDDevice: thingPDIDDevice
  }) : /*#__PURE__*/_react.default.createElement(_Circle.Circle, {
    isTransition: transition === _constants.circles.second,
    animationData: secondCircle
  }) : null) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: _CircleModule.default.circle
  })), [showDefault, firstCircle, secondCircle, typeFlow, typePower, isCorrectValue]);
}, (prev, next) => !(prev.thingPDIDDevice !== next.thingPDIDDevice || prev.isCorrectValue !== next.isCorrectValue || prev.displayNameId !== next.displayNameId || prev.type !== next.type));
var _default = exports.default = Circles;